import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'eduMatrix';

  private navigationErrorSubscription: Subscription;

  constructor(private router: Router, private toastr: ToastrService) {}

  public ngOnInit(): void {
    sessionStorage.setItem('orientationInfoDisplay', '1');

    this.navigationErrorSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationError))
      .subscribe(() => {
        this.toastr.error(
          'Nie udało się załadować strony. Sprawdź połączenie z internetem i spróbuj ponownie.',
          'Błąd ładowania'
        );
      });
  }

  public ngOnDestroy(): void {
    this.navigationErrorSubscription.unsubscribe();
  }
}
